import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import LocalizationConsumer from '../../../../l10n/localization-context';

import './link-text-option.less';

const LinkTextOption = ({ isHidden, onChange, linkText, isLinkTextEditable }) =>
{
  const classes = classnames({
    '-wa-edit-controls__property-container': true,
    '-wa-edit-controls__property-container_editable': isLinkTextEditable,
    '-wa-edit-controls__property-container_not-editable': !isLinkTextEditable,
    '-wa-edit-controls__property-container_hidden': isHidden || (!isLinkTextEditable && !linkText)
  });

  return (
    <div className={classes}>
      <div className="-wa-edit-controls__property-label -wa-edit-controls__property-label-link-text">
        <LocalizationConsumer id="insert-link-dialog.link-label" />
      </div>
        <div className="-wa-edit-controls__property-control">
          <input
            className="-wa-edit-controls__property-input -wa-edit-controls__property-link-text-input"
            name="linkText"
            value={linkText}
            onChange={e => onChange(e.target.value)}
            type="text"
            maxLength="1024"
          />
        </div>
        { !isLinkTextEditable ? (<div className="-wa-edit-controls__unchangeable-title" dangerouslySetInnerHTML={{ __html: linkText}}/>) : null }
    </div>
  )
};

LinkTextOption.propTypes = {
  isHidden: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  linkText: PropTypes.string.isRequired,
  isLinkTextEditable: PropTypes.bool.isRequired
};

export default LinkTextOption;